module.exports = __webpack_public_path__ + "static/assets/f606a8d70e2471fc1b04f7bc23ed2d26.svg";